import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, finalize, map, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionsService {
parseHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  // BehaviorSubject to emit subscription features when loaded
  private subscriptionFeaturesSubject = new BehaviorSubject<any>(null);
  public subscriptionFeatures$ = this.subscriptionFeaturesSubject.asObservable();

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
  ) {}

  public getFeatureFlagsFromApi(): void {
    this.loadSubscriptionFeatures().subscribe();
  }

  // In-flight API call, shared by concurrent callers (app load, login, route guard)
  private featuresRequest$: Observable<any> | null = null;

  /**
   * Feature access JSON of the active subscription plan ({ mobilemenu: [{ id, show, disable, children }] }).
   * Served from the 24h localStorage cache unless forceRefresh. Emits null when it could not be loaded.
   */
  public loadSubscriptionFeatures(forceRefresh: boolean = false): Observable<any> {
    if (!forceRefresh) {
      const cached = this.getCachedFeatures();
      if (cached) {
        //Using cached feature flags - emit only when changed so menus are not rebuilt on every guard check
        if (this.subscriptionFeaturesSubject.value?.lastFetchedAt !== cached.lastFetchedAt) {
          this.subscriptionFeaturesSubject.next(cached);
        }
        return of(cached);
      }
    }

    if (!this.featuresRequest$) {
      this.featuresRequest$ = this.getSellerSubscriptionFeatures().pipe(
        map((res: any) => {
          if (res?.Result !== "Success" || !res?.ResponseData) {
            console.warn('Subscription response not successful or missing data:', res);
            return null;
          }
          let suscriptionFeatures = {};
          try {
            suscriptionFeatures = JSON.parse(res?.ResponseData) ?? {};
          } catch (e) {
            console.error('Invalid JSON in ResponseData:', res?.ResponseData, e);
            suscriptionFeatures = {};
          }
          const dataWithTimestamp = {
            ...suscriptionFeatures,
            lastFetchedAt: new Date().toISOString()
          };
          localStorage.setItem('SubscriptionFeatures', JSON.stringify(dataWithTimestamp));
          this.subscriptionFeaturesSubject.next(dataWithTimestamp);
          return dataWithTimestamp;
        }),
        catchError((err: any) => {
          console.error(err);
          return of(null);
        }),
        finalize(() => this.featuresRequest$ = null),
        shareReplay(1)
      );
    }
    return this.featuresRequest$;
  }

  private getCachedFeatures(): any {
    try {
      const parsed = JSON.parse(localStorage.getItem('SubscriptionFeatures') ?? 'null');
      if (parsed?.lastFetchedAt && !this.isCacheExpired(parsed.lastFetchedAt)) {
        return parsed;
      }
    } catch (e) { }
    return null;
  }


  public getSellerSubscriptionFeatures() {
    const sendingData = {
    }
    const url = environment.subscriptionApiBaseUrl + '/SubscriptionApi/GetFeaturesBySubscriptionPlan';
    return this.http.get(url, this.parseHeaders);
  }

  public getSubscriptionFeatures() {
    return JSON.parse(localStorage.getItem('SubscriptionFeatures') || '{}');
  }

  public setSubscriptionFeaturesIfAuthenticated(){
    const userDetails = this.configService.getLoginDetails();
    if (userDetails?.Uuid) {
      this.getFeatureFlagsFromApi();
    }
  }

  private isCacheExpired(lastFetchedAt: string): boolean {
    const lastTime = new Date(lastFetchedAt).getTime();
    const now = Date.now();
    const diffInMs = now - lastTime;

    const hours24 = 24 * 60 * 60 * 1000;
    return diffInMs > hours24;
  }

}
